// Подключаем React
import * as React from "react";

// Подключаем необходимые нам компоненты
import { WidgetFrame } from "../studio/index.js";
// Файл "../studio/index.js" реэкспортирует все компоненты модулей:
// studio, frame и form; их можно подключить в одной строке.

// Экспорт страницы:
export { StudioSample };

/**
 * Новая страница Личной студии.
 * @returns {JSX.Element}.
 */
function StudioSample() {
  // Задаём меню действий
  const menu = [
    {
      icon: "download",
      name: "Выгрузить данные"
    }
  ];
  // Разметка виджета
  return (
    <WidgetFrame
      icon="survey"
      title="Список дисциплин"
      menu={menu}
    >
      Содержимое виджета
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
StudioSample.title = "Страница Личной студии";
